import { LineitemStatus } from "model/lineitems/lineitemStatus";

export enum CreativeStatus {
  NotLive = "NotLive",
  Live = "Live",
  Loading = "Loading",
}

export type IAssociatedLineitem = {
  campaignId: string;
  campaignName: string;
  id: string;
  name: string;
  status: LineitemStatus;
  isArchived?: boolean;
};
export type ICreativesUsageStatus = {
  [creativeId: string]: {
    status: CreativeStatus;
    associatedLineitems?: IAssociatedLineitem[];
  };
};

export const DEFAULT_CREATIVE_STATUS = {
  status: CreativeStatus.NotLive,
};
